import axios from "../services/api/api";

export const FETCH_ADMIN_USERS_BEGIN = "FETCH_ADMIN_USERS_BEGIN";
export const FETCH_ADMIN_USERS_FULFILLED = "FETCH_ADMIN_USERS_FULFILLED";
export const FETCH_ADMIN_USERS_REJECTED = "FETCH_ADMIN_USERS_REJECTED";

export function fetchAdminUsers() {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: FETCH_ADMIN_USERS_BEGIN
      });

      axios
        .get("/user")
        .then(response => {
          dispatch({
            type: FETCH_ADMIN_USERS_FULFILLED,
            payload: response.data.result
          });
          resolve("bulle");
        })
        .catch(err => {
          dispatch({
            type: FETCH_ADMIN_USERS_REJECTED,
            payload: err.hasOwnProperty("message") ? err.message : err
          });
          reject(err);
        });
    });
  };
}

export function deleteAdminUser(id) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/deleteuser/${id}`)
        .then(response => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}
